import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import reorderBackground from "../assets/reorderNumpad.png";
import { Textfit } from 'react-textfit';

export default function Keyboard({ currentQuestion, ...props }) {
  console.log(currentQuestion);
  console.log(props);

  const [reverseOrder, setReverseOrder] = useState(true);
  const [shift, setShift] = useState(false);
  const [answer, setAnswer] = useState([]);
  const [sentence, setSentence] = useState(currentQuestion.sentence);
  const [correct, setCorrect] = useState(currentQuestion.word);
  const [displayValue, setDisplayValue] = useState(
    props.singleUnderscore
      ? "_"
      : new Array(correct.length - answer.length).fill("_").join("")
  );
  const [showCorrectAnswer, setShowCorrectAnswer] = useState(false);

  useEffect(() => {
    window.addEventListener("keydown", downHandler);
    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener("keydown", downHandler);
    };
  }, [displayValue, answer, shift]);

  useEffect(() => {
    window.addEventListener("keyup", upHandler);
    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener("keyp", upHandler);
    };
  }, [displayValue, answer, shift]);

  useEffect(() => {
    if (props.singleUnderscore) {
      // If they haven't typed anything, show "_". 
      // The moment they start typing, show ONLY the word being typed.
      setDisplayValue(answer.length === 0 ? "_" : answer.join(""));
    } else {
      // Original behavior for standard mode
      setDisplayValue(
        answer.join("") +
        new Array(correct.length - answer.length).fill("_").join("")
      );
    }
  }, [answer, correct, props.singleUnderscore]);

  useEffect(() => {
    setSentence(currentQuestion.sentence);
    setCorrect(currentQuestion.word);
    setAnswer([]);
  }, [currentQuestion]);

  let vowels = ["a", "e", "i", "o", "u"];

  let valueButtonsRow1 = ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"];
  let valueButtonsRow2 = ["a", "s", "d", "f", "g", "h", "j", "k", "l", "del"];
  let valueButtonsRow3 = ["shift", "z", "x", "c", "v", "b", "n", "m", "'", "-"];

  function characterPress(character) {
    if (
      answer.length < correct.length &&
      (correct.toLowerCase().includes(character.toLowerCase()) ||
        props.additionalCharacters.includes(character.toLowerCase()) ||
        (character === "'" || character === "-"))
    ) {
      setAnswer([...answer, character]);
    }
  }

  function deleteCharacter() {
    if (answer.length > 0) {
      setAnswer(answer.slice(0, -1));
    }
  }

  function doKeyboardShift() {
    setShift(!shift);
  }

  function submit() {
    props.onSubmitted(answer.join(""), verdict => {
      return new Promise(function (resolve, reject) {
        if (verdict === false) {
          setShowCorrectAnswer(true);
          setTimeout(function () {
            setShowCorrectAnswer(false);
            setAnswer([]);
            return resolve();
          }, 2000);
        } else {
          setAnswer([]);
          return resolve();
        }
      });
    });
  }

  function downHandler({ key }) {
    switch (key) {
      case "Shift":
        setShift(true);
        break;
      case "Enter":
        if (answer.length > 0) {
          submit();
        }
        break;
      case "Backspace":
        deleteCharacter();
        break;
      default:
        characterPress(shift ? key.toUpperCase() : key);
        break;
    }
  }

  function upHandler({ key }) {
    switch (key) {
      case "Shift":
        setShift(false);
        break;
      default:
        break;
    }
  }

  useEffect(() => {
    if (showCorrectAnswer === true) {
    }
  }, [showCorrectAnswer]);

  const rows = [valueButtonsRow1, valueButtonsRow2, valueButtonsRow3];
  const { additionalCharacters } = props;

  //console.log(correct.split(""));

  return (
    <>
      <CalculatorContainer>
        <CalculatorFrame>
          <Answer>
            {showCorrectAnswer ? (
              <div style={{ display: "inline-flex", height: "80%", width: "80%", margin: "auto" }}>
                <Textfit mode="single" style={{ height: "90%" }}>{sentence.split("$")[0]}<span style={{ color: "green" }}> {correct} </span>{sentence.split("$")[1]}</Textfit>
              </div>
            ) : (
              <div style={{ display: "block", height: "80%", width: "80%", margin: "auto" }}>
                <Textfit mode="single" style={{ height: "90%" }}>{sentence.replace("$", displayValue)}</Textfit>
              </div>
            )}
          </Answer>

          <Numberpad>
            {rows.map(row => (
              <div style={{ display: "flex" }}>
                {row.map(value =>
                  value === "del" || value === "shift" ? (
                    <CancelButton
                      value={value}
                      active={correct
                        .toLowerCase()
                        .split("")
                        .includes(value)}
                      onClick={() => {
                        value === "shift"
                          ? doKeyboardShift()
                          : deleteCharacter();
                      }}
                    >
                      {value}
                    </CancelButton>
                  ) : value === "'" || value === "-" ? (
                    <PunctButton
                      value={correct.split("").includes(value) ? "" : value}
                      active={correct.split("").includes(value)}
                      vowel={vowels.includes(value)}
                      onClick={() =>
                        characterPress(shift ? value.toUpperCase() : value)
                      }
                    >
                      {correct.split("").includes(value) && (
                        <span>{shift ? value.toUpperCase() : value}</span>
                      )}
                    </PunctButton>
                  ) : (
                    <CalcButton
                      value={
                        correct.split("").includes(value) ||
                          additionalCharacters.includes(value) || correct.split("").includes(value.toUpperCase())
                          ? value
                          : value
                      }
                      active={
                        correct.split("").includes(value) ||
                        additionalCharacters.includes(value) || correct.split("").includes(value.toUpperCase())
                      }
                      vowel={vowels.includes(value)}
                      onClick={() =>
                        characterPress(shift ? value.toUpperCase() : value)
                      }
                    >
                      {(correct.split("").includes(value) || correct.split("").includes(value.toUpperCase()) ||
                        additionalCharacters.includes(value)) && (
                          <span>{shift ? value.toUpperCase() : value}</span>
                        )}
                    </CalcButton>
                  )
                )}
              </div>
            ))}
          </Numberpad>
        </CalculatorFrame>
      </CalculatorContainer>
      <div style={{ display: "flex", flexDirection: "row" }}>
        {props.playAudioButton && (
          <Button style={{ flex: 1, width: "300px" }} onClick={() => props.onPlayAudio()}>
            Play Audio
          </Button>
        )}
        <Button style={{ flex: 1, width: "300px" }} onClick={() => submit()}>
          Submit
        </Button>
      </div>
    </>
  );
}

const CalculatorFrame = styled.div`
  width: 800px;
  height: 400px;
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 10px;
  display: relative;
  padding: 0px 20px;
`;

const CalculatorContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const Numberpad = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: space-around;
`;

const Question = styled.input`
  height: 70px;
  line-height: 50px;
  user-select: none;
  font-size: 30px;
  margin: 15px 25px;
  text-align: center;
  font-weight: 600;
  border: none;
  border-radius: 10px;
`;

const Answer = styled.div`
  height: 100px;
  font-size: 2vw;
  align-items: center;
  justify-content: center;
  margin: 15px 25px;
  text-align: center;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  background: #fff;
`;

const CalcButton = styled.div`
  text-align: center;
  user-select: none;
  width: 10%;
  height: 70px;
  margin: 5px;
  color: ${props => (!props.active ? "rgba(0, 0, 0, 0)" : "#fff")};
  background: ${props =>
    !props.active
      ? "rgb(165, 165, 165) 0%,"
      : !props.vowel
        ? "green"
        : "rgb(234, 146, 19)"};
  background: ${props =>
    !props.active
      ? "linear-gradient(0deg, rgb(165, 165, 165) 0%, rgb(150, 150, 150) 100%)"
      : props.vowel
        ? "linear-gradient(0deg,rgba(25, 160, 63, 1) 0%,rgba(43, 196, 86, 1) 100%);"
        : "linear-gradient(0deg,rgba(234, 146, 19, 1) 0%,rgba(255, 186, 32, 1) 100%)"};
  border: 2px solid
    ${props =>
    !props.active
      ? "rgb(156, 154, 154)"
      : props.vowel
        ? "rgba(25, 160, 63, 1)"
        : "#e88f12"};

  padding: 0.5em;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: ${props => (props.active ? "pointer" : "")};
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;

const CancelButton = styled.div`
  text-align: center;
  width: 10%;
  height: 70px;
  margin: 5px;
  background: rgb(234, 29, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 29, 19, 1) 0%,
    rgba(255, 60, 50, 1) 100%
  );

  border: 2px solid rgb(234, 29, 19);
  color: #fff;
  user-select: none;
  padding: 0.5em;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 2.5em;
  cursor: pointer;
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;

const PunctButton = styled.div`
  text-align: center;
  width: 10%;
  height: 70px;
  margin: 5px;
  color: ${props => (!props.active ? "rgba(0, 0, 0, 0)" : "#fff")};
  background: ${props =>
    !props.active
      ? "rgb(165, 165, 165) 0%,"
      : !props.vowel
        ? "green"
        : "rgb(77, 45, 105)"};
  background: ${props =>
    !props.active
      ? "linear-gradient(0deg, rgb(165, 165, 165) 0%, rgb(150, 150, 150) 100%)"
      : props.vowel
        ? "linear-gradient(0deg,rgba(25, 160, 63, 1) 0%,rgba(43, 196, 86, 1) 100%);"
        : "linear-gradient(0deg, rgba(77, 45, 105, 1) 0%,rgba(104, 61, 140, 1) 100%);"};
  border: 2px solid
    ${props =>
    !props.active
      ? "rgb(156, 154, 154)"
      : props.vowel
        ? "rgba(25, 160, 63, 1)"
        : "rgb(77, 45, 105)"};

  padding: 0.5em;
  box-sizing: border-box;
  user-select: none;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: ${props => (props.active ? "pointer" : "")};
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;

const OKButton = styled.div`
  text-align: center;
  width: 10%;
  height: 70px;
  margin: 5px;
  background-color: #999;
  background: rgb(25, 160, 63);
  background: linear-gradient(
    0deg,
    rgba(25, 160, 63, 1) 0%,
    rgba(43, 196, 86, 1) 100%
  );
  border: 2px solid rgb(25, 160, 63);
  color: #fff;
  user-select: none;
  padding: 0.5em;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;

const Button = styled.div`
  text-align: center;
  width: 10%;
  height: 70px;
  margin: 5px;
  color: #fff;
  user-select: none;
  background: rgb(234, 146, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 146, 19, 1) 0%,
    rgba(255, 186, 32, 1) 100%
  );
  border: 2px solid #e88f12;
  padding: 0.5em;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;
